module.exports = __webpack_public_path__ + "img/icon-voice-assistant.2e3790db.svg";